import {useEffect, useState} from "react";

export function useIsTouchDevice() {
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        const hasTouch =
            typeof window !== "undefined" &&
            (navigator.maxTouchPoints > 0 || "ontouchstart" in window);

        setIsTouch(hasTouch);
    }, []);

    return isTouch;
}
